import {Fill, Icon, Style, Text} from 'ol/style';

const imgFlagHighlight = new URL(
	'~/src/img/flag-highlight.svg',
	import.meta.url
).toString();
const imgFlagNormal = new URL(
	'~/src/img/flag-normal.svg',
	import.meta.url
).toString();
const imgFlagFiltered = new URL(
	'~/src/img/flag-filtered.svg',
	import.meta.url
).toString();

const iconDefaults = {
	anchor: [0.5, 1],
	size: [48, 66],
	offset: [0, 0],
	opacity: 1,
	scale: 0.5,
};

function getIsActive(feature) {
	return feature.getProperties().isActive;
}

function getText(feature) {
	return feature.getProperties().name;
}

const styles = {
	select: (feature) =>
		new Style({
			image: new Icon({...iconDefaults, src: imgFlagHighlight}),
			zIndex: 400,
		}),
	selectHover: (feature) =>
		new Style({
			image: new Icon({...iconDefaults, src: imgFlagHighlight}),
			zIndex: 600,
			text: new Text({
				textAlign: 'center',
				textBaseline: 'top',
				font: 'normal 18px QuirogaSerifProItalic',
				text: getText(feature),
				offsetY: 2,
				fill: new Fill({color: '#CB8A00'}),
			}),
		}),
	normal: (feature) =>
		getIsActive(feature)
			? new Style({
					image: new Icon({...iconDefaults, src: imgFlagNormal}),
					zIndex: 200,
			  })
			: new Style({
					image: new Icon({...iconDefaults, src: imgFlagFiltered}),
					zIndex: 1,
			  }),
};

export default function styleFunction(feature, resolution, state = 'normal') {
	return styles[state](feature);
}
